'use client';

var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
class ManagedTimeout {
  constructor(remainingMs, callback) {
    __publicField(this, "timeout", null);
    __publicField(this, "lastTimeoutStart", Date.now());
    __publicField(this, "remainingMs");
    __publicField(this, "callback");
    this.remainingMs = remainingMs;
    this.callback = callback;
  }
  pause() {
    if (!this.timeout) return;
    this.remainingMs -= Date.now() - this.lastTimeoutStart;
    this.timeout = (this.timeout && clearTimeout(this.timeout)) ?? null;
  }
  resume() {
    if (this.timeout) return;
    this.timeout = setTimeout(this.callback, this.remainingMs);
    this.lastTimeoutStart = Date.now();
  }
}
export {
  ManagedTimeout
};
